import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import { PageResponse } from "app/common/Model/Shared";
import { pagingPatient } from "app/services/PatientService";
import {
  countingByHourly,
  saveOrUpdateAppointmentByStaff,
} from "app/services/AppointmentService";
import { handleGetQRCodeByValue } from "app/common/LocalFunction";
import {
  countingByHourlyPublic,
  pagingPatientByCode,
  pagingPatientByCodeOrPhone,
  pagingPatientByPhone,
  saveOrUpdateAppointmentByCustomer,
} from "app/services/PublicService";
import { SEARCH_TYPE_APPOINTMENT } from "app/common/LocalConst";

const DEFAULT_APPOINTMENT = {
  orderTime: new Date(),
  calendarSelect: new Date(),
  startTime: new Date(),
  searchType: SEARCH_TYPE_APPOINTMENT[0].value,
  uncompletedServices: [],
  appointmentCreator: null,
};

const DEFAULT_APPOINTMENT_BY_HOURLY = {
  customersAttended: 0,
  customersNotAttended: 0,
  customersCancelled: 0,
  customersFrom7To10: 0,
  customersFrom10To13: 0,
  customersFrom13To17: 0,
  customersFrom17To20: 0,
};
export default class AppointmentTracking {
  searchPatient = {
    ...new SearchObject(),
    pageSize: 10,
    searchType: SEARCH_TYPE_APPOINTMENT[0].value,
  };
  listPatients = new PageResponse();
  openFormCreateOrEdit = false;
  patientSelected = null;
  initialAppointment = {
    ...DEFAULT_APPOINTMENT,
  };
  countingByStatus = {};
  countingByHourly = {
    ...DEFAULT_APPOINTMENT_BY_HOURLY,
  };
  countingByDay = {};
  openSearchPatientPopup = false;
  openPopupQrUrl = false;
  dataPopupQrUrl = null;

  constructor() {
    makeAutoObservable(this);
  }

  handleSearchPatient = async () => {
    const isPublic = window.location.pathname.includes("public");
    let api = pagingPatient;
    if (isPublic) {
      let { searchType } = this.searchPatient;
      api = pagingPatientByCodeOrPhone;
      if (searchType === SEARCH_TYPE_APPOINTMENT[0].value) {
        this.searchPatient = {
          ...this.searchPatient,
          phoneNumber: this.searchPatient?.keyword,
          code: null,
        };
      } else {
        this.searchPatient = {
          ...this.searchPatient,
          code: this.searchPatient?.keyword,
          phoneNumber: null,
        };
      }
    }
    try {
      let { data } = await api({ ...this.searchPatient });
      this.listPatients = data;
      this.openSearchPatientPopup = true;
    } catch (error) {
      console.error(error);
      toast.error("Đã có lỗi xảy ra khi tìm khách hàng vui lòng thử lại!");
    }
  };

  handleChangeFormSearch = (searchPatient) => {
    let { keyword } = searchPatient;
    this.searchPatient = { ...this.searchPatient, ...searchPatient };
    // if (!keyword) {
    //   return;
    // }
    this.handleSearchPatient();
  };

  convertPatientServiceRegisterToAppointmentResourceItem = (payload) => {
    if (!payload) return;

    const uncompletedServices = Array.isArray(payload.uncompletedServices)
      ? payload.uncompletedServices
      : [];

    const newServices = [
      ...(Array.isArray(payload.services) ? payload.services : []),
      ...uncompletedServices.map((item) => ({
        ...item,
        code: item?.service?.code,
      })),
    ];

    return {
      ...payload,
      uncompletedServices,
      services: newServices,
    };
  };

  saveOrUpdateAppoint = async (obj, { setSubmitting }) => {
    const isPublic = window.location.pathname.includes("public");

    let api = saveOrUpdateAppointmentByStaff;
    if (isPublic) {
      api = saveOrUpdateAppointmentByCustomer;
    }

    obj = this.convertPatientServiceRegisterToAppointmentResourceItem(obj);

    return api(obj)
      .then(async ({ data }) => {
        toast.success("Đặt lịch thành công!");
        this.handleCountingByHourly({
          fromDate: obj?.startTime,
          toDate: obj?.endTime,
          departmentId: obj?.department?.id,
        });

        try {
          const qrCode = await handleGetQRCodeByValue(
            data?.patientAppointmentUrl
          );
          this.dataPopupQrUrl = {
            patient: { ...data?.patient, patientName: data?.patientName },
            qrCode,
          };
          this.openPopupQrUrl = true;
        } catch (error) {
          console.error("Failed to fetch QR code:", error);
        }
      })
      .catch((error) => {
        console.error(error);
        toast.error("Đặt lịch có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  handleCountingByHourly = async (values) => {
    const isPublic = window.location.pathname.includes("public");
    let api = countingByHourly;
    if (isPublic) {
      api = countingByHourlyPublic;
    }
    api(values)
      .then(({ data }) => {
        this.countingByHourly = data;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy thông tin lịch hẹn có lỗi");
      });
  };

  handleCloseSearchPatientPopup = () => {
    this.openSearchPatientPopup = false;
  };

  handleSelectSearchPatient = (patient) => {
    this.patientSelected = patient;
    this.initialAppointment = {
      ...this.initialAppointment,
      patient,
      // patient: { id: patient?.id },
      ...DEFAULT_APPOINTMENT,
    };
    this.openSearchPatientPopup = false;
  };

  handleSetInitialAppointment = (obj) => {
    this.handleCountingByHourly({
      fromDate: new Date(),
      toDate: new Date(),
      departmentId: obj?.department?.id,
    });
    this.dataPopupQrUrl = null;
    this.initialAppointment = obj;
  };

  handleOpenQrCodePopup = (state) => {
    this.openPopupQrUrl = state;
  };

  handleDownloadQRCode = () => {
    const link = document.createElement("a");
    link.href = this?.dataPopupQrUrl?.qrCode;
    link.download = "LINK_TRA_CUU_LICH_HEN.png";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  resetStore = () => {
    this.initialAppointment = { ...DEFAULT_APPOINTMENT };
    this.searchPatient = { ...new SearchObject(), pageSize: 10 };
    this.patientSelected = null;
    this.openSearchPatientPopup = false;
    this.countingByStatus = { ...DEFAULT_APPOINTMENT_BY_HOURLY };
    this.openPopupQrUrl = false;
    this.dataPopupQrUrl = null;
  };
}
